module.exports = __webpack_public_path__ + "img/chbar-ampov-branch.ec2d8b81.jpg";